var $=jQuery;
jQuery(document).ready(function ($) {
  $(".custom-anouncement-bar .grid").flickity({
    pageDots: false,
    freeScroll: false,
    wrapAround: true,
    prevNextButtons: false,
    autoPlay: 5000,
    groupCells: false,
    cellAlign: 'left',
    fade: true,
  });
  $('.button-row a.mehr').click(function (e) { 
      e.preventDefault();
      $(this).closest('.modal-info').addClass('active');
  });
  $('.button-row a.weniger').click(function (e) { 
      e.preventDefault();
      $(this).closest('.modal-info').removeClass('active');
  });
  $("#sort-options").on("change", function(){
    var container = $("#behandlungen-list");
    var items = container.children(".behandlung-item").get();
    var sortBy = $(this).val();

    items.sort(function(a, b){
        if(sortBy === "title"){
        var aVal = $(a).find(".title").text().toLowerCase();
        var bVal = $(b).find(".title").text().toLowerCase();
        return aVal.localeCompare(bVal);
        } else if(sortBy === "day"){
        var dateA = new Date($(a).data("date"));
        var dateB = new Date($(b).data("date"));
        return dateA - dateB;
        }
    });

    $.each(items, function(i, item){
        container.append(item);
    });
  });
  /** Ha add js click read more**/
 
  // if ($('.add-read-more').length > 0) {
      // var height = $('.innovation-st .button').height();
      // if(height < 140){
      //     $('.bottom-shop-row-button').hide();
      //     $('.add-read-more').toggleClass('active');
      // } 
      $('body').on('click', '.innovation-st .button', function (e) {
          $(this).toggleClass('active');
          $(this).closest('.multicolumn-card__info').find('.rte').toggleClass('active');
          // $(this).closest('.read-more-main').find('.bottom-shop-row-button a.button.primary.is-link').toggleClass('hidden');
          // $(this).closest('.read-more-main').find('.bottom-shop-row.add-read-more').toggleClass('active');
      });
  // }
 
  /** Ha add js click read more**/

  $('#scrollToTop').click(function() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  });
  $('.nt_komplettset a.button.button--primary[data="scroll_top"]').click(function() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  });
  function updateBorders() {
    $('.product__info-wrapper .color-custom').each(function (index) {
      const $swatch = $(this);
      const bg = $swatch.css('background-color');
      const $input = $('.product__info-wrapper input[type=radio]').eq(index);

      if (bg === 'rgb(255, 255, 255)') {
        if ($input.is(':checked')) {
          $swatch.css('border', 'none');
        } else {
          $swatch.css('border', '1px solid #000');
        }
      } else {
        $swatch.css('border', '');
      }
    });
  }

  updateBorders();

  $('.product__info-wrapper input[type=radio]').on('change', function () {
    updateBorders();
  });
  
  $(".color-option").on("click", function() {
      let src = $(this).attr("src");
      if (src) {
         $('.custom-img-click').attr('srcset', '');
         $(this).closest('.card-wrapper').find('.custom-img-click2').attr('srcset', src);  
          $(this).closest('.card-wrapper').find('.custom-img-click').attr('srcset', src);  
          $(this).closest('.card-wrapper').find('.custom-img-click2').attr('src', src);  
          $(this).closest('.card-wrapper').find('.custom-img-click').attr('src', src);  
      }
  }); 
  function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }

  var counted = false;
  if ($('.counter').length > 0) {
  $(window).on('scroll', function () {
    var $counter = $('.counter');
    if (isScrolledIntoView($counter) && !counted) {
      counted = true;

      $('.counter').each(function () {
        var show = '';
        var $this = $(this),
            countTo = $this.attr('data-count');
            show = $(this).attr('data-show');
    
        $({ countNum: $this.text() }).animate({
          countNum: countTo,
        },
        {
          duration: 2000,
          easing: 'swing',
          step: function () {
            $this.text(Math.floor(this.countNum));
          },
          complete: function () {
            $this.text(show);
          }
        });
      });
    }
  });
  }
  $('.acc-head').on('click', function() {
      if($(this).hasClass('active')) {
        $(this).siblings('.acc-content').slideUp();
        $(this).removeClass('active');
      }
      else {
        $('.acc-content').slideUp();
        $('.acc-head').removeClass('active');
        $(this).siblings('.acc-content').slideToggle();
        $(this).toggleClass('active');
      }
    });
  //slider mini cart
  var swiper = new Swiper('.slider-upsell', {
    slidesPerView: 1,
    spaceBetween:0,
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: 50000,
      disableOnInteraction: false,
    }
  });
  // $(".logos-container").flickity({
  //   pageDots: false,
  //   freeScroll: false,
  //   wrapAround: true,
  //   prevNextButtons: false,
  //   autoPlay: 6000,
  //   groupCells: false,
  //   cellAlign: 'left',
  // });
  if($(window).width() <= 949){
    $(".innovation-st.multicolumn .slider-mobile-gutter .multicolumn-list").flickity({
      pageDots: true,
      freeScroll: false,
      wrapAround: true,
      prevNextButtons: false,
      autoPlay: false,
      groupCells: false,
      cellAlign: 'left',
    });
    
  }
  $(".product-single__thumbnails").flickity({
      pageDots: false,
      freeScroll: false,
      wrapAround: true,
      prevNextButtons: true,
      autoPlay: false,
      groupCells: false,
      cellAlign: 'left',
     asNavFor: '.product-single__gallery'
  });
  $('.externe-berater-st .multicolumn-card__info h2, .has-dropdown-mobi p.sidebar-title').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
  
  $('.footer-block.has-dropdown .footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
});

document.addEventListener('DOMContentLoaded', function() {
    const loadMoreButton = document.querySelector('[data-pagination-btn]');
    const productGrid = document.getElementById('product-grid');
    
    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function(e) {
            e.preventDefault();
            const nextUrl = loadMoreButton.getAttribute('href');
            
            loadMoreButton.textContent = "Laden...";
            loadMoreButton.setAttribute('disabled', 'true');
            
            fetch(nextUrl)
                .then(response => response.text())
                .then(data => {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data;
                    
                    const newProducts = tempDiv.querySelector('#product-grid').innerHTML;
                    
                    productGrid.innerHTML += newProducts;
                    // const count = productGrid.querySelectorAll('.grid__item').length;
                    // let countDisplay = document.querySelector('p.products-count span.products-count');
                    // countDisplay.innerHTML = count;
                    // var sliderProducts = document.querySelectorAll('.has-slider-wrapper');

                    // sliderProducts.forEach(function(slider) {
                    //     new Flickity(slider, {
                    //         pageDots: false,
                    //         freeScroll: false,
                    //         wrapAround: true,
                    //         prevNextButtons: true,
                    //         autoPlay: false,
                    //         groupCells: false,
                    //         cellAlign: 'center',
                    //     });
                    // });
                    
                    const newButton = tempDiv.querySelector('[data-pagination-btn]');
                  
                    if (newButton) {
                        loadMoreButton.setAttribute('href', newButton.getAttribute('href'));
                        loadMoreButton.textContent = "MEHR ARTIKEL ANZEIGEN";
                        loadMoreButton.removeAttribute('disabled');
                    } else {
                        loadMoreButton.textContent = "Keine Produkte mehr";
                        loadMoreButton.style.display = "none";
                    }
                })
                .catch(error => {
                    console.error('Error loading more products:', error);
                    loadMoreButton.textContent = "Try again";
                    loadMoreButton.removeAttribute('disabled');
                });
        });
    }
});

